var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71087 7.05028C7.32034 7.4408 7.32034 8.07397 7.71087 8.46449L11.2464 12L7.71088 15.5356C7.32035 15.9261 7.32035 16.5593 7.71088 16.9498C8.1014 17.3403 8.73457 17.3403 9.12509 16.9498L12.6606 13.4142L16.1961 16.9498C16.5866 17.3403 17.2198 17.3403 17.6103 16.9498C18.0008 16.5592 18.0008 15.9261 17.6103 15.5356L14.0748 12L17.6103 8.46449C18.0008 8.07397 18.0008 7.4408 17.6103 7.05028C17.2198 6.65976 16.5866 6.65976 16.1961 7.05028L12.6606 10.5858L9.12508 7.05028C8.73456 6.65975 8.10139 6.65975 7.71087 7.05028Z",
    fill: "#534DE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlue);
export default __webpack_public_path__ + "static/media/close_blue.0be79460d9244ebad92f951bece37e6e.svg";
export { ForwardRef as ReactComponent };